import { MessageIcon } from './MessageIcon';

/**
 * author: Google
 * id 99DA4752-8C79-44D8-8286-6EBD696F0B45
 * name message
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message.svg
 * tags
 */
export const ChatBubbleIcon = MessageIcon;
export default ChatBubbleIcon